import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { FaCookieBite } from "react-icons/fa";
import { IoMdClose } from "react-icons/io"; // Icona per la X

const CookieConsentBanner = () => {
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [showBanner, setShowBanner] = useState(false);
  const [showCookieIcon, setShowCookieIcon] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!cookies.cookieConsent) {
      setShowBanner(true);
    } else {
      setShowCookieIcon(true);
    }
  }, [cookies]);


  const acceptCookies = () => {
    setCookie("cookieConsent", "accepted", { path: "/", maxAge: 31536000 });
    setShowBanner(false);
    setShowCookieIcon(true);
  
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted'
      });
  
      window.gtag('event', 'page_view', {
        page_path: window.location.pathname
      });
    }
  };

  const declineCookies = () => {
    setCookie("cookieConsent", "declined", { path: "/", maxAge: 31536000 });
    setShowBanner(false);
    setShowCookieIcon(true);
  };

  // Nuova funzione per chiudere la modale e navigare
  const handleCookieInfoClick = () => {
    // Chiudi la modale
    setShowBanner(false);
    // Naviga alla pagina di informazioni cookie
    navigate("/cookie");
  };

  let consentMessage = "Seleziona un'opzione per personalizzare la tua esperienza.";
  if (cookies.cookieConsent === "accepted") {
    consentMessage = "Hai accettato tutti i cookie. Clicca 'Solo necessari' qui sotto per la navigazione del sito senza personalizzazione.";
  } else if (cookies.cookieConsent === "declined") {
    consentMessage = "Stai utilizzando solo i cookie essenziali. Clicca 'Accetta tutti i cookie' per avere un'esperienza personalizzata in base alla tua attività sulla piattaforma.";
  }

  return (
    <>
      {showBanner && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white text-gray-900 p-6 md:p-8 rounded-lg shadow-lg max-w-lg w-11/12 text-center relative">
            {cookies.cookieConsent && (
              <button
                onClick={() => setShowBanner(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              >
                <IoMdClose className="text-2xl" />
              </button>
            )}

            <h2 className="text-xl md:text-2xl font-semibold text-wild-ocean font-heading text-start mb-4">
              AIUTACI A MIGLIORARE 
              LA TUA<br /> ESPERIENZA SU SAVE YOUR TRAVEL 🍪
            </h2>
            <p className="text-base text-gray-700 mb-4 text-start">
              Utilizziamo i cookie e altre tecnologie per personalizzare i contenuti, misurare l’efficacia degli annunci pubblicitari e offrire un’esperienza d’uso ottimizzata. Alcuni cookie sono necessari per il funzionamento del sito e non possono essere disattivati. Acconsentendo al loro utilizzo, dichiari di accettare l’
              <span 
                onClick={handleCookieInfoClick} 
                className="text-wild-ocean underline cursor-pointer"
              >
                informativa sui cookie di Save Your Travel.
              </span>
            </p>
            <p className="text-sm font-medium text-start text-gray-800 mt-8 mb-4">
              {consentMessage}
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button 
                onClick={acceptCookies} 
                disabled={cookies.cookieConsent === "accepted"} 
                className={`w-full sm:w-1/2 uppercase font-heading text-white px-5 py-2 rounded-md transition text-sm md:text-base ${
                  cookies.cookieConsent === "accepted" 
                    ? "bg-gray-400 cursor-not-allowed" 
                    : "bg-wild-ocean hover:bg-blue-700"
                }`}
              >
                {cookies.cookieConsent === "accepted" ? "Cookies Accettati" : "Accetta tutti"}
              </button>
              <button 
                onClick={declineCookies} 
                disabled={cookies.cookieConsent === "declined"} 
                className={`w-full sm:w-1/2 uppercase font-heading px-5 py-2 rounded-md transition text-sm md:text-base ${
                  cookies.cookieConsent === "declined" 
                    ? "text-gray-500 cursor-not-allowed underline" 
                    : "text-wild-ocean underline hover:bg-gray-100"
                }`}
              >
                {cookies.cookieConsent === "declined" ? "Cookie necessari Attivi" : "Solo quelli necessari"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showCookieIcon && (
        <div className="fixed bottom-24 left-4 md:bottom-10 md:left-12 z-50">
          <button
            onClick={() => setShowBanner(true)}
            className="bg-white shadow-lg rounded-full p-3 flex items-center justify-center text-wild-ocean hover:bg-gray-100 transition"
          >
            <FaCookieBite className="text-3xl" />
          </button>
        </div>
      )}
    </>
  );
};

export default CookieConsentBanner;
